export default __webpack_public_path__ + "static/media/Educo.cc48023b.png";